module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center",
    attrs: {
      "id": "chap5"
    }
  }, [_vm._v("Feb. 15")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The Morning After")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The Night Before")]), _vm._v(" "), _c('p', {
    staticClass: "ind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("How could he do it?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I can’t figure it out.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A day later, a whole night’s sleep, and I’m supposed to be calmer and more rational but my teeth are still gritted so hard I haven’t tried eating breakfast and I’m not hungry anyway because I AM STILL FURIOUS.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Did he think I’d LIKE to be surprised like that? Is he that stupid?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Or was I wrong about him? Has he REALLY gone Cro Mag on me? Maybe the other goons were watching the whole scene behind the jukebox. Taking pictures. Videotaping. “The Humiliation of Ducky, as choreographed by Jay Adams.” Order your copies now, folks!")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Or is it ME? Maybe this is NORMAL. Maybe guys DO this kind of thing for other guys.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Maybe you’re supposed to like it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("So now what?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Are you supposed to call the girl and ask her on another date? Hold hands in the hallway and walk to classes together and save seats for each other at the lunch table?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("How can you do ANY of that when you can barely remember what she looks like and what you REALLY need to do is talk to your traitor-friend and ask him WHAT IS IN HIS TWISTED MIND. Which you can’t even do because your fingers get to 555-837 and then—FREEZE—you feel all tongue-tied. What can you say when your mind is so full of anger you want to scream and you’re afraid that’s just what you’ll do, which will cause your ex-best friend to hang up and never hear your side of the story at all?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("You put down the phone and leave, that’s what.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("You spend some time alone.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Part 2 of the Continuing Saga:")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How Not to Choose Your Friends")]), _vm._v(" "), _c('p', {
    staticClass: "ind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("What you do is, you fly through town on your bike to Las Palmas County Park and hit the trail so fast you nearly run over a hiker who calls you nasty names and makes you feel even worse, if that’s possible. So you slow down and you remember the place where you used to hide when you were a kid and you needed to be alone, the place hidden in the reeds by the bank of the creek near the old bridge. And you smile, remembering the summer days you and Alex used to spend there—just talking—and as you’re gliding across that bridge you see a mass of black pants and a flannel shirt hiding in the same spot and you tense up, figuring you’re going to be sneak-attacked by a Cro Mag, or maybe he’s strung fishing wire across the bridge at neck level—and the pants and shirt turn out to be Alex.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("So you skid to a stop, jump off the bike, and walk around the bridge. And you have a conversation that goes something like this:")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Ducky: “Hey, Alex!” [Pause, pause, pause…] “Uh, Alex, hi! What’s up?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Alex: [Looks up. Expression hardly changes.] “Oh. Yo. Nothing much.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “Waiting for somebody?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A: “Nahh.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “Just, like, sitting?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A: “Yup.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “Wow. Just like the old days, huh?” [Pause, pause, pause.] “Well, nice day for sitting.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A: [Nods. Pulls grass from the ground and tosses it aside.]")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “Are you okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A: “Yup.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “Okay, well, bye.” [Walks away.]")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A: “Hey. Ducky. That Valentine’s Day flower? That was cool.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A: “Nicest thing anyone’s given me in months.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("BONNNNG, rings a bell in the cuckoo clock of your brain. And out comes a little bird that says, “Déjà VU. Déjà VU. Déjà VU.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Here’s where you see, for the first time on this stage in many a year, folks, the Person That Was Once Alex.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Because you knew—somehow YOU JUST KNEW—that he was going to say that. And maybe you just knew he’d be near the bridge. And you haven’t had those ESP-ish feelings in a million years.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But you’re not exactly sure how to take what he said. The nicest thing? Your stupid little Cupid carnation that you gave to everybody? He must be joking. In which case it’s the first hint of humor you’ve heard from the New Alex.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But he’s not smiling. The expression on his face is very Old Alex, and it tells you he’s speaking the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And that’s about the saddest thing you’ve heard all day.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “Are you serious?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A: “Why shouldn’t I be?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “Well, it’s just that…you know, not "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("everybody")]), _vm._v(" felt that way. Jay didn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A: “He’s an ape.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “He’s just going through a stage. He’s okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A: “If you say so.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Conversation fizzles. Home you go.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What a day. You start it off ready to strangle one ex-best friend, then you end up DEFENDING him to your other ex-best friend, who is slowly flickering away like a doused campfire that isn’t quite out yet.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("So maybe you should talk to Alex again. REALLY talk. Maybe divorces DO have a delayed effect on some kids. Imagine how YOU would feel if YOUR parents were divorced.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Of course, if your parents divorced, you might not even know about it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Do they have divorces in Ghana?")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("A Phone Conversation")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("In Which")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Sunny’s Law of Gender Conduct")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Is Discussed")]), _vm._v(" "), _c('p', {
    staticClass: "ind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Sunny says, call Jay.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I say she’s nuts. He should call ME!")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Sunny says I’m a guy. He’s a guy. Guys TALK TO EACH OTHER after they fight. They argue and explode and say things girls would never think of saying to each other, and then it all blows over and they play basketball.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I tell her I hate basketball.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She doesn’t find that funny. She yells at me. She insists she’s just using common sense.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I tell her I’ll think about it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Not good enough. She threatens to call me back in a half hour. If I haven’t phoned Jay, or if I don’t pick up, I am in the doghouse.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I bark.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She hangs up.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Okay, McCrae, now what?")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Department of Twists and Turns")]), _vm._v(" "), _c('p', {
    staticClass: "ind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("I did it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I reached Jay’s answering machine.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The reason I got the answering machine was that Jay was out on his bike.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The place he was biking to was my house.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He rang the doorbell.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I didn’t answer.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Half-past Anger")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Quarter to Crisis")]), _vm._v(" "), _c('p', {
    staticClass: "ind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Love")]), _vm._v(" makes the world go round? Wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Guilt does.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("You do something like not answer the door and suddenly you feel like a criminal, and you worry that your friend actually saw you or heard your breathing while he was at the door, and you picture him storming away angrily and knowing finally beyond the shadow of a doubt that you are chicken.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("So you feel guilty. And you drive around town in your car, pretending to yourself that you’re just going for a drive, but your eyes are constantly looking for him, and you figure if you see him you can casually say, “Hey, what’s up?” And it’ll seem like a coincidence.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But you don’t see him. And that makes you feel worse.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("So you finally drive to his house.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He’s there. And he’s all smiles.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It’s the Duckster! Duckopolis! Duckman! Duckorama!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Slap. Slap. Slap. Slap. That’s what each of those stupid names feels like.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He says right out: He was just over at your house, and you were out—which makes you gulp.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Then he says he has to show you something.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("So he takes you around back, where there used to be an old, rusted basketball hoop on the garage. But now there’s a new one, and the driveway has been widened and painted to look like a basketball court.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Jay is obviously very proud of this. And he makes you play basketball. He is bouncing or dribbling or whatever you call that, and you’re hopping along beside him the way they teach you in gym class, even though you don’t know why in the WORLD you’re doing it, and you feel about as athletic as a turnip. And on top of that, you have to listen to Jay Adams’s running commentary on himself: “He fakes…he drives to the baseline…he shoots…off the rim…the offensive rebound…he pumps…”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The ball goes over your head, swishes into the basket, “Yyyyesssss!” shouts Jay, and you have had enough.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("You tell him you don’t want to play.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But he’s not really listening. His eyes are looking over your shoulder. At the driveway.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What a great coincidence, Jay says. He has to go to the mall, and YOU’VE conveniently brought your car.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("You sputter. You start to tell him exactly WHY you came over, but you can’t find the words, because really you don’t know, do you? And while you’re fuzzing out, he’s already halfway down the driveway.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Hop in. Start. Drive. Ducky McCrae, chauffeur to the world.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And you finally talk. Only it doesn’t QUITE go the way you expected. It goes something like this:")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("J: “you recovered yet?” he nudges you in the ribs, which is the wrong thing to do to a driver, and you swerve into the left lane, narrowly missing an oncoming car.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “@#$%&!!!” On the verge of a heart attack.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("J: [laughing hysterically]: “DWI—driving while intickle-icated!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “Okay. To answer your question, no. I haven’t recovered, if you’re talking about the diner—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("J: “LeeAnn! What a babe!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("J: “LeeAnn? The girl at the diner? Hello? Earth to Duckomatic?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “Oh! Well, you know, I had no idea—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("J: “Surprise! You should have seen the look on your face! HOW WAS THE RIDE HOME?—HAR HAR! Did you have a good time?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “Okay…you want the truth?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("J: “No, JUST THE DETAILS!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “As a matter of fact, it was miserable. So was the dinner itself. I felt humiliated and awkward and trapped and I can’t believe you did that to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Dead silence.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("J [Deep sigh.]: “You blew it, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “Whaaat?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("J: “Duckmeister, if you want the girl, you have to "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("make conversation")]), _vm._v(". You can’t expect to score if you don’t play the game—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “I wasn’t playing a game! I was having dinner!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("J: “You know what I mean. It’s "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("like")]), _vm._v(" a game. With rules and penalties and fake-outs and long shots—just like basketball. You have to talk the talk, walk the walk—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “What you did was WRONG, Jay. You should have told me in advance. I thought it was going to be just you and me—not you, me, Lisa, and a total stranger.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("J: “She’s not a stranger. She’s one of Lisa’s best friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “I DON’T CARE!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("J: “Okay, so you didn’t like her, it didn’t work out, whatever. It happens. Now look, there’s this "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("other")]), _vm._v(" girl I know—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “Jay, hello? Do you understand a word I’m saying?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("J: “I understand a lot. You didn’t have a Valentine, dude. I’m concerned about you. Plenty of UGLY guys have Valentines. Why shouldn’t YOU? You just have an inferiority complex or something, that’s all. Nothing that a real girlfriend wouldn’t cure. Anyway, her name is Barb—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “Is this all you can think of—girls? What is with you? You never used to be like this!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("J: “I’m trying to "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("help")]), _vm._v(" you, Duckovich. Most guys would be thanking me. You think it was easy getting a babe like LeeAnn to go on a blind date? I had to talk you up. I said you were buff. Did you ever think YOU may be the one letting me down?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There’s the mall. The gate to the garage is in sight, but you have NO INTENTION of going in, so you pull up to the curb and nearly shear off your whitewalls.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “YOU ARE MISSING THE WHOLE POINT, JAY!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("J: “YOU’RE the one missing the point! Of life!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “Get out.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("J: “Huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("D: “You heard me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Jay unbuckles. Opens door. Steps out. Slams door.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("You step on the gas. You are out of there.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7030fab0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/v5/8chap5.vue
// module id = 84
// module chunks = 0